var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7794_56280",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7794_56280)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0.585786,
    width: 16.1836,
    height: 16.1836,
    transform: "rotate(45 12 0.585786)",
    fill: "#4611A7",
    stroke: "#4611A7",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.0016,
    cy: 7.28539,
    r: 1.66746,
    transform: "rotate(45 12.0016 7.28539)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.7114,
    cy: 11.9997,
    r: 1.66746,
    transform: "rotate(45 16.7114 11.9997)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.9984,
    cy: 16.7141,
    r: 1.66746,
    transform: "rotate(45 11.9984 16.7141)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.28552,
    cy: 11.9997,
    r: 1.66746,
    transform: "rotate(45 7.28552 11.9997)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFilledIcon);
export default __webpack_public_path__ + "static/media/home-filled-icon.fc54b409e184b78937cb74917f46808c.svg";
export { ForwardRef as ReactComponent };